import { Adapter as r } from "../../../adapter.js";
import { ProfileModel as n } from "./profile.model.js";
class s extends r {
  adapt(e) {
    return new n(
      e.country,
      e.email,
      e.external_id,
      e.first_name,
      e.gender,
      e.locale,
      e.name,
      e.phone,
      e.surname,
      !!e.marketing_permission,
      e.postal_code,
      e.birthdate ? new Date(e.birthdate * 1e3) : void 0,
      e.avatar
    );
  }
  serialize(e) {
    return {
      ...e.firstName ? { name: e.firstName } : {},
      ...e.email ? { email: e.email } : {},
      ...e.gender ? { gender: e.gender } : {},
      ...e.locale ? { locale: e.locale } : {},
      ...e.phone ? { phone_number: e.phone } : {},
      ...e.surname ? { surname: e.surname } : {},
      ...e.birthdate ? { birth_date: Math.floor(e.birthdate.getTime() / 1e3) } : {},
      ...e.postalCode ? { postal_code: e.postalCode } : {},
      ...e.avatar ? { avatar: e.avatar } : {}
    };
  }
}
export {
  s as ProfileAdapter
};
//# sourceMappingURL=profile.adapter.js.map
